/* tslint:disable */
/* eslint-disable */
export enum OrganizationHierarchyModeEnum {
  DirectChildren = 'DirectChildren',
  FullHierarchy = 'FullHierarchy'
}
